import { useQuery } from '@tanstack/react-query';
import { leavePolicyService } from '@/services/leave/leavePolicyService';
import { leaveQueryKeys } from './queryKeys';
import { useAuth } from '@/hooks/useAuth';

export const useLeaveBalances = (
  profileId?: string,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    queryKey: leaveQueryKeys.balances(profileId),
    queryFn: () => leavePolicyService.getLeaveBalances(profileId),
    staleTime: 2 * 60 * 1000, // 2 minutes
    enabled: options?.enabled ?? true
  });
};

export const useMyLeaveBalances = () => {
  const { profile } = useAuth();
  
  return useQuery({
    queryKey: leaveQueryKeys.myBalances(profile?.id || ''),
    queryFn: () => leavePolicyService.getLeaveBalances(profile?.id),
    enabled: !!profile?.id,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};